import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Check, ArrowRight } from 'lucide-react';
import { SEOHelmet, SEO_CONFIG } from '@/components/SEOHelmet';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <>
      <SEOHelmet {...SEO_CONFIG.home} />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-pink-50">
        {/* Header */}
        <header className="bg-white/90 backdrop-blur-sm border-b border-neutral-100 sticky top-0 z-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
            <div className="flex items-center justify-between">
              <img src="/logo-landing.png" alt="Remindora" className="h-8 sm:h-10 w-auto object-contain" />
              <Button 
                onClick={() => navigate('/auth')} 
                variant="ghost"
                className="text-purple-600 hover:text-purple-700 hover:bg-purple-50"
              >
                Giriş Yap
              </Button>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-neutral-900 mb-6 leading-tight">
            Partnerinle Özel Günleri
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 mt-2">
              Asla Unutma
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-neutral-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Her gün sana özel planlar, hatırlatmalar ve sürpriz fikirler.<br />
            Sevgilinle daha keyifli bir ilişki için yapay zekâ destekli asistan.
          </p>
          
          <Button 
            onClick={() => navigate('/auth')} 
            size="lg"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-12 py-7 text-xl font-semibold shadow-xl hover:shadow-2xl transition-all"
          >
            Ücretsiz Başla
            <ArrowRight className="w-6 h-6 ml-2" />
          </Button>
          
          <p className="text-sm text-neutral-400 mt-4">
            Hesap oluşturmak 30 saniye sürer.
          </p>
        </section>

        {/* Features */}
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-neutral-900 mb-1">Özel gün hatırlatır</h3>
                <p className="text-sm text-neutral-600">Yıldönümü, doğum günü - hiçbirini kaçırma</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-neutral-900 mb-1">Partner ilgi alanlarına göre sürpriz önerir</h3>
                <p className="text-sm text-neutral-600">AI sayesinde tam ona göre hediyeler</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-neutral-900 mb-1">Günlük dış/ev/aktivite planları</h3>
                <p className="text-sm text-neutral-600">Hava durumuna göre akıllı öneriler</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-neutral-900 mb-1">Unutkanlık sıfır, sürpriz maksimum</h3>
                <p className="text-sm text-neutral-600">Push bildirimler ile her zaman hazır</p>
              </div>
            </div>
          </div>
        </section>

        {/* İçeride Ne Var */}
        <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-2xl font-bold text-center text-neutral-900 mb-8">Remindora ile Keşfet</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white rounded-xl shadow-md p-6 text-center border border-neutral-100">
              <h3 className="text-lg font-semibold text-neutral-900">Günlük öneriler</h3>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center border border-neutral-100">
              <h3 className="text-lg font-semibold text-neutral-900">Planlama kartları</h3>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center border border-neutral-100">
              <h3 className="text-lg font-semibold text-neutral-900">Partner profili</h3>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-white border-t border-neutral-200 py-8 mt-12">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-6 text-sm text-neutral-600">
                <a href="/kvkk" className="hover:text-purple-600">KVKK</a>
                <a href="/feedback" className="hover:text-purple-600">Geri Bildirim</a>
                <button onClick={() => navigate('/auth')} className="hover:text-purple-600">Giriş Yap</button>
              </div>
              <p className="text-sm text-neutral-500">© 2025 Remindora • bilgilendirme@remindora.io</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
